import React from 'react';
import styles from './styles.css';

const ToraConfirmation = ({ custodianName, custodianCustomerServicePhone }) => (
  <section className="next-instructions">
    <div className="step-contents">
      <h3>
        Complete your transfer from <strong>{custodianName}</strong>
      </h3>
      <p>
        {custodianName} will require you to liquidate your investments in order
        to complete the transfer. Call to find out and liquidate, if needed.
      </p>
      <p>
        <small>{custodianName} customer service:</small>
      </p>
      <a href={`tel:${custodianCustomerServicePhone}`}>
        {custodianCustomerServicePhone}
      </a>
      <style jsx>{styles}</style>
    </div>
  </section>
);

export default ToraConfirmation;
